import { render, staticRenderFns } from "./EditTeacher.vue?vue&type=template&id=895359d4&scoped=true&"
import script from "./EditTeacher.vue?vue&type=script&lang=js&"
export * from "./EditTeacher.vue?vue&type=script&lang=js&"
import style0 from "./EditTeacher.vue?vue&type=style&index=0&id=895359d4&lang=scss&scoped=true&"
import style1 from "./EditTeacher.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895359d4",
  null
  
)

export default component.exports